import { UserProfileSelectProps } from 'modules/queryBuilder/contexts/visualComponents';
import { SingleValueUserProfileSelect as UserProfileSelect } from 'ui/queryBuilder';
import { useShouldFilterFieldsAndProperties } from './useShouldFilterFieldsAndProperties';

export const JourneyUserPropertySelect = (props: UserProfileSelectProps) => {
  const shouldFilterFieldsAndProperties = useShouldFilterFieldsAndProperties();
  // remove the geo location properties as we do not show these in the Journey Studio
  const options = props.options?.filter((option) => !option.value.includes('geo_'));
  return (
    <UserProfileSelect
      {...props}
      isDisabled={!!shouldFilterFieldsAndProperties}
      options={options}
    />
  );
};
